import { PLAN } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import PlanPage from "./container/PlanPage";

export default function getSettingsRoute(userAuth) {
  const { account, cpfm } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [cpfm.name]: [cpfm.roles.admin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: PLAN,
    withSidebar: false,
    withAppBar: false,
    component: PlanPage,
  };
}
